import Spinner from '@/components/Spinner';
import IconV2 from '@/components/v2/IconV2';
import { InformationIcon } from '@/lib/constants/icons';

const ArgumentInputRowLabel = ({ className = '', dataTitle, description, icon, isRequired, label, loading, onClick, title, custom = false }) => {
  const getFullTitle = () => {
    if (!title) {
      return;
    }
    return `${title}${isRequired ? ' (required)' : ''}`;
  };

  const fullTitle = getFullTitle();

  const handleClick = () => {
    if (loading) {
      return;
    }

    onClick?.();
  };

  return (
    <div className={`option-label ${isRequired ? 'required' : ''} ${className}`.trim()} onClick={handleClick}>
      {icon && <IconV2 icon={loading ? <Spinner /> : icon} title={fullTitle} className={custom ? 'custom' : ''} />}
      {label && <span data-title={dataTitle || label}>{label}</span>}
      {description && <IconV2 icon={InformationIcon} title={description} className={'argument-description'} variant={'light'} />}
    </div>
  );
};

export default ArgumentInputRowLabel;
